import Table from './table/index';
import Progress from './progress/index';
import PhotoPreview from './photo-preview/index';
import BtnImg from './btn-img/index';

const kComponents = {
    install: function (Vue) {
        Vue.component('k-table', Table);
        Vue.component('k-progress', Progress);
        Vue.component('k-preview', PhotoPreview);
        Vue.component('k-btn-img', BtnImg);
    }
};

export default kComponents;



// WEBPACK FOOTER //
// ./src/components/index.js